// Roughly a page of text. Mirrors MAX_TEXT_WORDS in backend/app.py - keep
// both in sync if this changes.
export const MAX_TEXT_WORDS = 500;

export function countWords(text) {
    const trimmed = text.trim();
    return trimmed === "" ? 0 : trimmed.split(/\s+/).length;
}
